import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

const BannerWrap = styled.div`
  margin: 0 ${rem(-24)};
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  &.flush {
    margin: 0;
  }
`

const emphasis = (chunks: React.ReactNode) => (
  <BodyText as="span" variant="medium" weight="bold">{chunks}</BodyText>
)

interface Props {
  flush?: boolean
}

function MaldivesCharterReturnForFreeCalendarBanner({ flush = false }: Props) {
  return (
    <BannerWrap className={flush ? 'flush' : undefined} data-testid="maldives-charter-return-for-free-calendar-banner">
      <BodyTextBlock variant="medium" colour="lux-plus" startIcon={<SolidFireIcon />}>
        <FormattedMessage
          id="bt96LAYE88GI0QoegUQ9"
          defaultMessage="<em>Maldives return for free flight sale.</em> Exclusive to LuxPlus+ members and on select dates and packages only."
          description="Banner under the Maldives charter calendar header explaining that some dates include a free return flight for LuxPlus members"
          values={{ em: emphasis }}
        />
      </BodyTextBlock>
    </BannerWrap>
  )
}

export default MaldivesCharterReturnForFreeCalendarBanner
